import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import VorteileSection from "@/components/VorteileSection";
import StepsSection from "@/components/StepsSection";
import SloganSection from "@/components/SloganSection";
import PreislisteSection from "@/components/PreislisteSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import StandortSection from "@/components/StandortSection";
import Footer from "@/components/Footer";
import SectionDivider from "@/components/SectionDivider";
import HaftungshinweisBanner from "@/components/HaftungshinweisBanner";

const Index = () => {
  return (
    <div className="min-h-screen overflow-x-hidden bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <VorteileSection />
        <SloganSection />
        <div className="deferred-section">
          <SectionDivider />
        </div>
        <StepsSection />
        <PreislisteSection />
        <div className="deferred-section">
          <TestimonialsSection />
        </div>
        <FAQSection />
        <div className="deferred-section">
          <SectionDivider />
        </div>
        <div className="deferred-section">
          <StandortSection />
        </div>
      </main>
      <Footer />
      <HaftungshinweisBanner />
    </div>
  );
};

export default Index;
